import React, { useCallback } from 'react';
import propTypes from 'prop-types';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import RegistrationModal from 'pages/RegistrationModal/RegistrationModal';
import Button from 'components/Button/Button';
import { RegistrationModalCaller } from 'pages/RegistrationModal/utils';
import CookieStorageService from 'services/CookieStorageService';

import loginUserImage from '../../../../images/icon-user.png';
import styles from '../Header.css';


function GuestMenu(props) {
  const {
    appActions: { setShowRegistrationModal },
    openRegistrationModal,
    setIsAnyModalShown,
    showRegistrationModal,
  } = props;

  const onOpenLoginModal = useCallback(() => {
    ModalService.showModal(ModalService.MODAL_KEYS.LOGIN_MODAL_V2, {
      handleOpenRegistrationModal: () => setShowRegistrationModal(true, RegistrationModalCaller.PROFILE),
      setIsAnyModalShown,
    });
    const hasCam4Models = CookieStorageService.get('Cam4_Models');
    if (hasCam4Models) {
      CookieStorageService.remove('Cam4_Models');
    }
    setIsAnyModalShown?.(true);
  }, [
    setIsAnyModalShown,
    setShowRegistrationModal,
  ]);

  return (
    <div className={styles.user}>
      <RegistrationModal showRegistrationModal={showRegistrationModal} />
      <div className={styles.dropdown} id="dropdown-menu">
        <div className={styles.headerElement}>
          <Button
            className={styles.headerButton}
            id="loginButton"
            onClick={onOpenLoginModal}
          >
            <img
              alt={translate('profile.profile.Current.Avatar')}
              className={styles.headerButtonImage}
              src={loginUserImage}
            />
            <p className={styles.headerButtonText}>
              {translate('login.login.header.v2')}
            </p>
          </Button>
        </div>
      </div>
      <div className={styles.createFreeAcc}>
        <Button
          className={styles.createFreeAccBtn}
          colour="orange"
          id="createAccount"
          label={translate('strings.LoginView.create')}
          size="small"
          onClick={openRegistrationModal}
        />
      </div>
    </div>
  );
}

GuestMenu.propTypes = {
  appActions: propTypes.object,
  openRegistrationModal: propTypes.func,
  setIsAnyModalShown: propTypes.func,
  showRegistrationModal: propTypes.bool,
};

GuestMenu.defaultProps = {
  appActions: undefined,
  history: undefined,
  openRegistrationModal: () => undefined,
  setIsAnyModalShown: undefined,
  showRegistrationModal: undefined,
  userActions: undefined,
};

export default GuestMenu;
